// This file is auto-generated by @hey-api/openapi-ts

import { type Options as ClientOptions, type TDataShape, type Client, formDataBodySerializer } from '@hey-api/client-axios';
import type { ApiAddressesFormatPostData, ApiAddressesFormatPostResponses, ApiAddressesFormatPostErrors, ApiAddressesIdFormatGetData, ApiAddressesIdFormatGetResponses, ApiAddressesIdFormatGetErrors, ApiAddressesIdFormatPatchData, ApiAddressesIdFormatPatchResponses, ApiAddressesIdFormatPatchErrors, ApiBinlookupsFormatGetCollectionData, ApiBinlookupsFormatGetCollectionResponses, ApiBinlookupsBinFormatDeleteData, ApiBinlookupsBinFormatDeleteResponses, ApiBinlookupsBinFormatDeleteErrors, ApiBinlookupsBinFormatGetData, ApiBinlookupsBinFormatGetResponses, ApiBinlookupsBinFormatGetErrors, ApiTransactionSignatureFormatPostData, ApiTransactionSignatureFormatPostResponses, ApiTransactionSignatureFormatPostErrors, ApiTransactionsauthorizedFormatGetCollectionData, ApiTransactionsauthorizedFormatGetCollectionResponses, ApiTransactionsauthorizedTransactionIdFormatGetData, ApiTransactionsauthorizedTransactionIdFormatGetResponses, ApiTransactionsauthorizedTransactionIdFormatGetErrors, FaCheckData, FaCheckResponses, FaCheckErrors, UserLoginData, UserLoginErrors, LogoutData, LogoutErrors, ApiBatchesFormatGetCollectionData, ApiBatchesFormatGetCollectionResponses, ApiBatchesBatchIdFormatGetData, ApiBatchesBatchIdFormatGetResponses, ApiBatchesBatchIdFormatGetErrors, ApiBinlookupsuploadFormatPostData, ApiBinlookupsuploadFormatPostResponses, ApiBinlookupsuploadFormatPostErrors, ApiCardTokensTokenFormatGetData, ApiCardTokensTokenFormatGetResponses, ApiCardTokensTokenFormatGetErrors, ApiCheckTokensTokenFormatGetData, ApiCheckTokensTokenFormatGetResponses, ApiCheckTokensTokenFormatGetErrors, ApiCustomerAddressAuditsFormatGetCollectionData, ApiCustomerAddressAuditsFormatGetCollectionResponses, ApiCustomerAddressAuditsFormatGetCollectionErrors, ApiCustomersFormatGetCollectionData, ApiCustomersFormatGetCollectionResponses, ApiCustomersFormatGetCollectionErrors, ApiCustomersFormatPostData, ApiCustomersFormatPostResponses, ApiCustomersFormatPostErrors, ApiCustomersIdFormatGetData, ApiCustomersIdFormatGetResponses, ApiCustomersIdFormatGetErrors, ApiCustomersIdFormatPatchData, ApiCustomersIdFormatPatchResponses, ApiCustomersIdFormatPatchErrors, ApiUsersmemfaProvidersProviderFormatGetData, ApiUsersmemfaProvidersProviderFormatGetResponses, ApiUsersmemfaProvidersProviderFormatGetErrors, ApiCustomersinvoicesIdpayFormatPostData, ApiCustomersinvoicesIdpayFormatPostResponses, ApiCustomersinvoicesIdpayFormatPostErrors, ApiInvoicesFormatGetCollectionData, ApiInvoicesFormatGetCollectionResponses, ApiInvoicesFormatPostData, ApiInvoicesFormatPostResponses, ApiInvoicesFormatPostErrors, ApiInvoicesclosedIdFormatPatchData, ApiInvoicesclosedIdFormatPatchResponses, ApiInvoicesclosedIdFormatPatchErrors, ApiInvoicesdownloadIdGetData, ApiInvoicesdownloadIdGetResponses, ApiInvoicesdownloadIdGetErrors, ApiInvoicesexportGetCollectionData, ApiInvoicesexportGetCollectionResponses, ApiInvoicespayIdFormatPostData, ApiInvoicespayIdFormatPostResponses, ApiInvoicespayIdFormatPostErrors, ApiInvoicespreviewFormatPostData, ApiInvoicespreviewFormatPostResponses, ApiInvoicespreviewFormatPostErrors, ApiInvoicespublicIdFormatGetData, ApiInvoicespublicIdFormatGetResponses, ApiInvoicespublicIdFormatGetErrors, ApiInvoicesresendIdFormatPostData, ApiInvoicesresendIdFormatPostResponses, ApiInvoicesresendIdFormatPostErrors, ApiInvoicesIdFormatGetData, ApiInvoicesIdFormatGetResponses, ApiInvoicesIdFormatGetErrors, ApiInvoicesIdFormatPatchData, ApiInvoicesIdFormatPatchResponses, ApiInvoicesIdFormatPatchErrors, ApiMerchantDefinedFieldsFormatGetCollectionData, ApiMerchantDefinedFieldsFormatGetCollectionResponses, ApiMerchantDefinedFieldsFormatPostData, ApiMerchantDefinedFieldsFormatPostResponses, ApiMerchantDefinedFieldsFormatPostErrors, ApiMerchantDefinedFieldsIdFormatDeleteData, ApiMerchantDefinedFieldsIdFormatDeleteResponses, ApiMerchantDefinedFieldsIdFormatDeleteErrors, ApiMerchantDefinedFieldsIdFormatGetData, ApiMerchantDefinedFieldsIdFormatGetResponses, ApiMerchantDefinedFieldsIdFormatGetErrors, ApiMerchantDefinedFieldsIdFormatPatchData, ApiMerchantDefinedFieldsIdFormatPatchResponses, ApiMerchantDefinedFieldsIdFormatPatchErrors, ApiMerchantsFormatGetCollectionData, ApiMerchantsFormatGetCollectionResponses, ApiMerchantsFormatPostData, ApiMerchantsFormatPostResponses, ApiMerchantsFormatPostErrors, ApiMerchantsMerchAccountIdFormatDeleteData, ApiMerchantsMerchAccountIdFormatDeleteResponses, ApiMerchantsMerchAccountIdFormatDeleteErrors, ApiMerchantsMerchAccountIdFormatGetData, ApiMerchantsMerchAccountIdFormatGetResponses, ApiMerchantsMerchAccountIdFormatGetErrors, ApiMerchantsMerchAccountIdFormatPatchData, ApiMerchantsMerchAccountIdFormatPatchResponses, ApiMerchantsMerchAccountIdFormatPatchErrors, ApiObjectFilesFormatGetCollectionData, ApiObjectFilesFormatGetCollectionResponses, ApiObjectFilesFormatPostData, ApiObjectFilesFormatPostResponses, ApiObjectFilesFormatPostErrors, ApiPaymentsIdFormatGetData, ApiPaymentsIdFormatGetResponses, ApiPaymentsIdFormatGetErrors, ApiProductCategoriesFormatGetCollectionData, ApiProductCategoriesFormatGetCollectionResponses, ApiProductCategoriesFormatPostData, ApiProductCategoriesFormatPostResponses, ApiProductCategoriesFormatPostErrors, ApiProductCategoriesIdFormatDeleteData, ApiProductCategoriesIdFormatDeleteResponses, ApiProductCategoriesIdFormatDeleteErrors, ApiProductCategoriesIdFormatGetData, ApiProductCategoriesIdFormatGetResponses, ApiProductCategoriesIdFormatGetErrors, ApiProductCategoriesIdFormatPatchData, ApiProductCategoriesIdFormatPatchResponses, ApiProductCategoriesIdFormatPatchErrors, ApiProductDetailByLocationFormatGetCollectionData, ApiProductDetailByLocationFormatGetCollectionResponses, ApiProductDetailByLocationFormatPostData, ApiProductDetailByLocationFormatPostResponses, ApiProductDetailByLocationFormatPostErrors, ApiProductDetailByLocationIdFormatDeleteData, ApiProductDetailByLocationIdFormatDeleteResponses, ApiProductDetailByLocationIdFormatDeleteErrors, ApiProductDetailByLocationIdFormatGetData, ApiProductDetailByLocationIdFormatGetResponses, ApiProductDetailByLocationIdFormatGetErrors, ApiProductDetailByLocationIdFormatPatchData, ApiProductDetailByLocationIdFormatPatchResponses, ApiProductDetailByLocationIdFormatPatchErrors, ApiProductLocationsFormatGetCollectionData, ApiProductLocationsFormatGetCollectionResponses, ApiProductLocationsFormatPostData, ApiProductLocationsFormatPostResponses, ApiProductLocationsFormatPostErrors, ApiProductLocationsIdFormatDeleteData, ApiProductLocationsIdFormatDeleteResponses, ApiProductLocationsIdFormatDeleteErrors, ApiProductLocationsIdFormatGetData, ApiProductLocationsIdFormatGetResponses, ApiProductLocationsIdFormatGetErrors, ApiProductLocationsIdFormatPatchData, ApiProductLocationsIdFormatPatchResponses, ApiProductLocationsIdFormatPatchErrors, ApiProductPackageProductDetailByLocationPackageIdFormatGetCollectionData, ApiProductPackageProductDetailByLocationPackageIdFormatGetCollectionResponses, ApiProductPackagesFormatGetCollectionData, ApiProductPackagesFormatGetCollectionResponses, ApiProductPackagesFormatPostData, ApiProductPackagesFormatPostResponses, ApiProductPackagesFormatPostErrors, ApiProductPackagesIdFormatDeleteData, ApiProductPackagesIdFormatDeleteResponses, ApiProductPackagesIdFormatDeleteErrors, ApiProductPackagesIdFormatGetData, ApiProductPackagesIdFormatGetResponses, ApiProductPackagesIdFormatGetErrors, ApiProductPackagesIdFormatPatchData, ApiProductPackagesIdFormatPatchResponses, ApiProductPackagesIdFormatPatchErrors, ApiProductStockOrderItemsStockOrderIdFormatGetCollectionData, ApiProductStockOrderItemsStockOrderIdFormatGetCollectionResponses, ApiProductStockOrderStatusIdFormatPatchData, ApiProductStockOrderStatusIdFormatPatchResponses, ApiProductStockOrderStatusIdFormatPatchErrors, ApiProductStockOrdersFormatGetCollectionData, ApiProductStockOrdersFormatGetCollectionResponses, ApiProductStockOrdersFormatPostData, ApiProductStockOrdersFormatPostResponses, ApiProductStockOrdersFormatPostErrors, ApiProductStockOrdersIdFormatDeleteData, ApiProductStockOrdersIdFormatDeleteResponses, ApiProductStockOrdersIdFormatDeleteErrors, ApiProductStockOrdersIdFormatGetData, ApiProductStockOrdersIdFormatGetResponses, ApiProductStockOrdersIdFormatGetErrors, ApiProductStockOrdersIdFormatPatchData, ApiProductStockOrdersIdFormatPatchResponses, ApiProductStockOrdersIdFormatPatchErrors, ApiProductsFormatGetCollectionData, ApiProductsFormatGetCollectionResponses, ApiProductsFormatPostData, ApiProductsFormatPostResponses, ApiProductsFormatPostErrors, ApiProductsIdFormatDeleteData, ApiProductsIdFormatDeleteResponses, ApiProductsIdFormatDeleteErrors, ApiProductsIdFormatGetData, ApiProductsIdFormatGetResponses, ApiProductsIdFormatGetErrors, ApiProductsIdFormatPatchData, ApiProductsIdFormatPatchResponses, ApiProductsIdFormatPatchErrors, ApiPlansFormatGetCollectionData, ApiPlansFormatGetCollectionResponses, ApiPlansFormatPostData, ApiPlansFormatPostResponses, ApiPlansFormatPostErrors, ApiPlansIdFormatDeleteData, ApiPlansIdFormatDeleteResponses, ApiPlansIdFormatDeleteErrors, ApiPlansIdFormatGetData, ApiPlansIdFormatGetResponses, ApiPlansIdFormatGetErrors, ApiPlansIdFormatPatchData, ApiPlansIdFormatPatchResponses, ApiPlansIdFormatPatchErrors, ApiRecurStatusRecurIdFormatPatchData, ApiRecurStatusRecurIdFormatPatchResponses, ApiRecurStatusRecurIdFormatPatchErrors, ApiRecursFormatGetCollectionData, ApiRecursFormatGetCollectionResponses, ApiRecursFormatPostData, ApiRecursFormatPostResponses, ApiRecursFormatPostErrors, ApiRecursIdFormatDeleteData, ApiRecursIdFormatDeleteResponses, ApiRecursIdFormatDeleteErrors, ApiRecursIdFormatGetData, ApiRecursIdFormatGetResponses, ApiRecursIdFormatGetErrors, ApiRecursIdFormatPatchData, ApiRecursIdFormatPatchResponses, ApiRecursIdFormatPatchErrors, ApiTransactionSignatureIdFormatGetData, ApiTransactionSignatureIdFormatGetResponses, ApiTransactionSignatureIdFormatGetErrors, ApiBatchesreopenBatchIdFormatPostData, ApiBatchesreopenBatchIdFormatPostResponses, ApiBatchesreopenBatchIdFormatPostErrors, ApiManagebdkFormatGetCollectionData, ApiManagebdkFormatGetCollectionResponses, ApiManagebdkFormatGetCollectionErrors, ApiManagebdkFormatPostData, ApiManagebdkFormatPostResponses, ApiManagebdkFormatPostErrors, ApiManagebdkIdFormatDeleteData, ApiManagebdkIdFormatDeleteResponses, ApiManagebdkIdFormatDeleteErrors, ApiManagebdkIdFormatGetData, ApiManagebdkIdFormatGetResponses, ApiManagebdkIdFormatGetErrors, ApiManagebdkIdFormatPatchData, ApiManagebdkIdFormatPatchResponses, ApiManagebdkIdFormatPatchErrors, ApiTransactionsallFormatGetCollectionData, ApiTransactionsallFormatGetCollectionResponses, ApiTransactionsauthToSaleFormatPostData, ApiTransactionsauthToSaleFormatPostResponses, ApiTransactionsauthToSaleFormatPostErrors, ApiTransactionsbatchCloseFormatPostData, ApiTransactionsbatchCloseFormatPostResponses, ApiTransactionsbatchCloseFormatPostErrors, ApiTransactionsbatchedFormatGetCollectionData, ApiTransactionsbatchedFormatGetCollectionResponses, ApiTransactionsbatchedTransactionIdFormatGetData, ApiTransactionsbatchedTransactionIdFormatGetResponses, ApiTransactionsbatchedTransactionIdFormatGetErrors, ApiTransactionsblindReturnFormatPostData, ApiTransactionsblindReturnFormatPostResponses, ApiTransactionsblindReturnFormatPostErrors, ApiTransactionscheckStoreFormatPostData, ApiTransactionscheckStoreFormatPostResponses, ApiTransactionscheckStoreFormatPostErrors, ApiTransactionsdeclinedFormatGetCollectionData, ApiTransactionsdeclinedFormatGetCollectionResponses, ApiTransactionsdeclinedTransactionIdFormatGetData, ApiTransactionsdeclinedTransactionIdFormatGetResponses, ApiTransactionsdeclinedTransactionIdFormatGetErrors, ApiTransactionserrorFormatGetCollectionData, ApiTransactionserrorFormatGetCollectionResponses, ApiTransactionserrorTransactionIdFormatGetData, ApiTransactionserrorTransactionIdFormatGetResponses, ApiTransactionserrorTransactionIdFormatGetErrors, ApiTransactionsincrementalFormatPostData, ApiTransactionsincrementalFormatPostResponses, ApiTransactionsincrementalFormatPostErrors, ApiTransactionsreEnterFormatPostData, ApiTransactionsreEnterFormatPostResponses, ApiTransactionsreEnterFormatPostErrors, ApiTransactionsreturnFormatPostData, ApiTransactionsreturnFormatPostResponses, ApiTransactionsreturnFormatPostErrors, ApiTransactionsreversalFormatPostData, ApiTransactionsreversalFormatPostResponses, ApiTransactionsreversalFormatPostErrors, ApiTransactionssaleFormatPostData, ApiTransactionssaleFormatPostResponses, ApiTransactionssaleFormatPostErrors, ApiTransactionssettledFormatGetCollectionData, ApiTransactionssettledFormatGetCollectionResponses, ApiTransactionssettledTransactionIdFormatGetData, ApiTransactionssettledTransactionIdFormatGetResponses, ApiTransactionssettledTransactionIdFormatGetErrors, ApiTransactionsstoreFormatPostData, ApiTransactionsstoreFormatPostResponses, ApiTransactionsstoreFormatPostErrors, ApiTransactionsvoidFormatPostData, ApiTransactionsvoidFormatPostResponses, ApiTransactionsvoidFormatPostErrors, ApiTransactionsTransactionIdreceiptFormatGetData, ApiTransactionsTransactionIdreceiptFormatGetResponses, ApiTransactionsTransactionIdreceiptFormatGetErrors, ApiUsersFormatGetCollectionData, ApiUsersFormatGetCollectionResponses, ApiUsersFormatGetCollectionErrors, ApiUsersPostData, ApiUsersPostResponses, ApiUsersPostErrors, ApiUsersmeFormatGetData, ApiUsersmeFormatGetResponses, ApiUsersmeFormatGetErrors, ApiUsersmechangePasswordFormatPatchData, ApiUsersmechangePasswordFormatPatchResponses, ApiUsersmechangePasswordFormatPatchErrors, ApiUsersmedisableMfaFormatPatchData, ApiUsersmedisableMfaFormatPatchResponses, ApiUsersmedisableMfaFormatPatchErrors, ApiUsersmegenerateMfaBackupCodesFormatPostData, ApiUsersmegenerateMfaBackupCodesFormatPostResponses, ApiUsersmegenerateMfaBackupCodesFormatPostErrors, ApiUsersmegenerateMfaEmailAuthCodeFormatPostData, ApiUsersmegenerateMfaEmailAuthCodeFormatPostResponses, ApiUsersmegenerateMfaEmailAuthCodeFormatPostErrors, ApiUsersmegenerateMfaGoogleTotpFormatPostData, ApiUsersmegenerateMfaGoogleTotpFormatPostResponses, ApiUsersmegenerateMfaGoogleTotpFormatPostErrors, ApiUsersmemfaProvidersFormatGetCollectionData, ApiUsersmemfaProvidersFormatGetCollectionResponses, ApiUsersmemfaProvidersFormatPostData, ApiUsersmemfaProvidersFormatPostResponses, ApiUsersmemfaProvidersFormatPostErrors, ApiUsersmepreferMfaFormatPatchData, ApiUsersmepreferMfaFormatPatchResponses, ApiUsersmepreferMfaFormatPatchErrors, ApiUsersmesetupMfaEmailAuthCodeFormatPostData, ApiUsersmesetupMfaEmailAuthCodeFormatPostResponses, ApiUsersmesetupMfaEmailAuthCodeFormatPostErrors, ApiUsersmesetupMfaGoogleTotpFormatPostData, ApiUsersmesetupMfaGoogleTotpFormatPostResponses, ApiUsersmesetupMfaGoogleTotpFormatPostErrors, ApiUsersrequestResetPasswordFormatPostData, ApiUsersrequestResetPasswordFormatPostResponses, ApiUsersrequestResetPasswordFormatPostErrors, ApiUsersresetMfaAccountIdFormatPatchData, ApiUsersresetMfaAccountIdFormatPatchResponses, ApiUsersresetMfaAccountIdFormatPatchErrors, ApiUsersresetPasswordFormatPostData, ApiUsersresetPasswordFormatPostResponses, ApiUsersresetPasswordFormatPostErrors, ApiUsersresetPasswordIdFormatGetData, ApiUsersresetPasswordIdFormatGetResponses, ApiUsersresetPasswordIdFormatGetErrors, ApiUsersIdDeleteData, ApiUsersIdDeleteResponses, ApiUsersIdDeleteErrors, ApiUsersIdFormatGetData, ApiUsersIdFormatGetResponses, ApiUsersIdFormatGetErrors, ApiUsersIdFormatPatchData, ApiUsersIdFormatPatchResponses, ApiUsersIdFormatPatchErrors } from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Create new address
 * Creates a PostAddressResource resource.
 */
export const apiAddressesFormatPost = <ThrowOnError extends boolean = false>(options: Options<ApiAddressesFormatPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApiAddressesFormatPostResponses, ApiAddressesFormatPostErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/addresses',
        ...options,
        headers: {
            'Content-Type': 'application/ld+json',
            ...options.headers
        }
    });
};

/**
 * Get a single address by customer_id and address_id.
 * Retrieves a Address resource.
 */
export const apiAddressesIdFormatGet = <ThrowOnError extends boolean = false>(options: Options<ApiAddressesIdFormatGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiAddressesIdFormatGetResponses, ApiAddressesIdFormatGetErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/addresses/{id}',
        ...options
    });
};

/**
 * Update a address
 * Updates the PatchAddressResource resource.
 */
export const apiAddressesIdFormatPatch = <ThrowOnError extends boolean = false>(options: Options<ApiAddressesIdFormatPatchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<ApiAddressesIdFormatPatchResponses, ApiAddressesIdFormatPatchErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/addresses/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/merge-patch+json',
            ...options.headers
        }
    });
};

/**
 * Retrieves the collection of BinRanges resources.
 * Retrieves the collection of BinRanges resources.
 */
export const apiBinlookupsFormatGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiBinlookupsFormatGetCollectionData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ApiBinlookupsFormatGetCollectionResponses, unknown, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/bin/lookups',
        ...options
    });
};

/**
 * Removes the BinRanges resource.
 * Removes the BinRanges resource.
 */
export const apiBinlookupsBinFormatDelete = <ThrowOnError extends boolean = false>(options: Options<ApiBinlookupsBinFormatDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<ApiBinlookupsBinFormatDeleteResponses, ApiBinlookupsBinFormatDeleteErrors, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/bin/lookups/{bin}',
        ...options
    });
};

/**
 * Retrieves a BinRanges resource.
 * Retrieves a BinRanges resource.
 */
export const apiBinlookupsBinFormatGet = <ThrowOnError extends boolean = false>(options: Options<ApiBinlookupsBinFormatGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiBinlookupsBinFormatGetResponses, ApiBinlookupsBinFormatGetErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/bin/lookups/{bin}',
        ...options
    });
};

/**
 * Create new signature.
 * # Create new signature.
 */
export const apiTransactionSignatureFormatPost = <ThrowOnError extends boolean = false>(options: Options<ApiTransactionSignatureFormatPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApiTransactionSignatureFormatPostResponses, ApiTransactionSignatureFormatPostErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/transaction_signature',
        ...options,
        headers: {
            'Content-Type': 'application/ld+json',
            ...options.headers
        }
    });
};

/**
 * Retrieves the collection of AuthorizedTransaction resources.
 * Retrieves the collection of AuthorizedTransaction resources.
 */
export const apiTransactionsauthorizedFormatGetCollection = <ThrowOnError extends boolean = false>(options: Options<ApiTransactionsauthorizedFormatGetCollectionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiTransactionsauthorizedFormatGetCollectionResponses, unknown, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/transactions/authorized',
        ...options
    });
};

/**
 * Retrieves a AuthorizedTransaction resource.
 * Retrieves a AuthorizedTransaction resource.
 */
export const apiTransactionsauthorizedTransactionIdFormatGet = <ThrowOnError extends boolean = false>(options: Options<ApiTransactionsauthorizedTransactionIdFormatGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiTransactionsauthorizedTransactionIdFormatGetResponses, ApiTransactionsauthorizedTransactionIdFormatGetErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/transactions/authorized/{transaction_id}',
        ...options
    });
};

/**
 * MFA check
 * Checking MFA after user logged in
 */
export const faCheck = <ThrowOnError extends boolean = false>(options: Options<FaCheckData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<FaCheckResponses, FaCheckErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/2fa_check',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * User login
 * User login to the system
 */
export const userLogin = <ThrowOnError extends boolean = false>(options: Options<UserLoginData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<unknown, UserLoginErrors, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/login',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * User logout
 * User logout from the system
 */
export const logout = <ThrowOnError extends boolean = false>(options?: Options<LogoutData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, LogoutErrors, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/logout',
        ...options
    });
};

/**
 * Get all batches
 * Retrieves the collection of Batch resources.
 */
export const apiBatchesFormatGetCollection = <ThrowOnError extends boolean = false>(options: Options<ApiBatchesFormatGetCollectionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiBatchesFormatGetCollectionResponses, unknown, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/batches',
        ...options
    });
};

/**
 * Get batch detail by batch id
 * Retrieves a Batch resource.
 */
export const apiBatchesBatchIdFormatGet = <ThrowOnError extends boolean = false>(options: Options<ApiBatchesBatchIdFormatGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiBatchesBatchIdFormatGetResponses, ApiBatchesBatchIdFormatGetErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/batches/{batch_id}',
        ...options
    });
};

/**
 * Creates a PostBinUploadResource resource.
 * Creates a PostBinUploadResource resource.
 */
export const apiBinlookupsuploadFormatPost = <ThrowOnError extends boolean = false>(options?: Options<ApiBinlookupsuploadFormatPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<ApiBinlookupsuploadFormatPostResponses, ApiBinlookupsuploadFormatPostErrors, ThrowOnError>({
        ...formDataBodySerializer,
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/bin/lookups/upload',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * Retrieves a CardStore resource.
 * Retrieves a CardStore resource.
 */
export const apiCardTokensTokenFormatGet = <ThrowOnError extends boolean = false>(options: Options<ApiCardTokensTokenFormatGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiCardTokensTokenFormatGetResponses, ApiCardTokensTokenFormatGetErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/card_tokens/{token}',
        ...options
    });
};

/**
 * Retrieves a CheckStore resource.
 * Retrieves a CheckStore resource.
 */
export const apiCheckTokensTokenFormatGet = <ThrowOnError extends boolean = false>(options: Options<ApiCheckTokensTokenFormatGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiCheckTokensTokenFormatGetResponses, ApiCheckTokensTokenFormatGetErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/check_tokens/{token}',
        ...options
    });
};

/**
 * Get all customer address audits
 * Retrieves the collection of CustomerAddressAudit resources.
 */
export const apiCustomerAddressAuditsFormatGetCollection = <ThrowOnError extends boolean = false>(options: Options<ApiCustomerAddressAuditsFormatGetCollectionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiCustomerAddressAuditsFormatGetCollectionResponses, ApiCustomerAddressAuditsFormatGetCollectionErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/customer_address_audits',
        ...options
    });
};

/**
 * Get all customers
 * Retrieves the collection of Customer resources.
 */
export const apiCustomersFormatGetCollection = <ThrowOnError extends boolean = false>(options: Options<ApiCustomersFormatGetCollectionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiCustomersFormatGetCollectionResponses, ApiCustomersFormatGetCollectionErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/customers',
        ...options
    });
};

/**
 * Create new customer
 * Creates a PostCustomerResource resource.
 */
export const apiCustomersFormatPost = <ThrowOnError extends boolean = false>(options: Options<ApiCustomersFormatPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApiCustomersFormatPostResponses, ApiCustomersFormatPostErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/customers',
        ...options,
        headers: {
            'Content-Type': 'application/ld+json',
            ...options.headers
        }
    });
};

/**
 * Get a single customer
 * Retrieves a Customer resource.
 */
export const apiCustomersIdFormatGet = <ThrowOnError extends boolean = false>(options: Options<ApiCustomersIdFormatGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiCustomersIdFormatGetResponses, ApiCustomersIdFormatGetErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/customers/{id}',
        ...options
    });
};

/**
 * Update a customer
 * Updates the PatchCustomerResource resource.
 */
export const apiCustomersIdFormatPatch = <ThrowOnError extends boolean = false>(options: Options<ApiCustomersIdFormatPatchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<ApiCustomersIdFormatPatchResponses, ApiCustomersIdFormatPatchErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/customers/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/merge-patch+json',
            ...options.headers
        }
    });
};

/**
 * Retrieves a GetMfaProviderResource resource.
 * Retrieves a GetMfaProviderResource resource.
 */
export const apiUsersmemfaProvidersProviderFormatGet = <ThrowOnError extends boolean = false>(options: Options<ApiUsersmemfaProvidersProviderFormatGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiUsersmemfaProvidersProviderFormatGetResponses, ApiUsersmemfaProvidersProviderFormatGetErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/users/me/mfa_providers/{provider}',
        ...options
    });
};

/**
 * Pay an invoice.
 * # Pay an invoice.
 */
export const apiCustomersinvoicesIdpayFormatPost = <ThrowOnError extends boolean = false>(options: Options<ApiCustomersinvoicesIdpayFormatPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApiCustomersinvoicesIdpayFormatPostResponses, ApiCustomersinvoicesIdpayFormatPostErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/customers/invoices/{id}/pay',
        ...options,
        headers: {
            'Content-Type': 'application/ld+json',
            ...options.headers
        }
    });
};

/**
 * Retrieves the collection of Invoice resources.
 * Retrieves the collection of Invoice resources.
 */
export const apiInvoicesFormatGetCollection = <ThrowOnError extends boolean = false>(options: Options<ApiInvoicesFormatGetCollectionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiInvoicesFormatGetCollectionResponses, unknown, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/invoices',
        ...options
    });
};

/**
 * Create an invoice.
 * # Create an invoice.
 */
export const apiInvoicesFormatPost = <ThrowOnError extends boolean = false>(options: Options<ApiInvoicesFormatPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApiInvoicesFormatPostResponses, ApiInvoicesFormatPostErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/invoices',
        ...options,
        headers: {
            'Content-Type': 'application/ld+json',
            ...options.headers
        }
    });
};

/**
 * Close an invoice.
 * Updates the CloseInvoiceResource resource.
 */
export const apiInvoicesclosedIdFormatPatch = <ThrowOnError extends boolean = false>(options: Options<ApiInvoicesclosedIdFormatPatchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<ApiInvoicesclosedIdFormatPatchResponses, ApiInvoicesclosedIdFormatPatchErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/invoices/closed/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/merge-patch+json',
            ...options.headers
        }
    });
};

/**
 * Download an invoice.
 * Retrieves a Invoice resource.
 */
export const apiInvoicesdownloadIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiInvoicesdownloadIdGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiInvoicesdownloadIdGetResponses, ApiInvoicesdownloadIdGetErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/invoices/download/{id}',
        ...options
    });
};

/**
 * Export list of invoices
 * Retrieves the collection of Invoice resources.
 */
export const apiInvoicesexportGetCollection = <ThrowOnError extends boolean = false>(options: Options<ApiInvoicesexportGetCollectionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiInvoicesexportGetCollectionResponses, unknown, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/invoices/export',
        ...options
    });
};

/**
 * Pay an invoice.
 * # Pay an invoice.
 */
export const apiInvoicespayIdFormatPost = <ThrowOnError extends boolean = false>(options: Options<ApiInvoicespayIdFormatPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApiInvoicespayIdFormatPostResponses, ApiInvoicespayIdFormatPostErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/invoices/pay/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/ld+json',
            ...options.headers
        }
    });
};

/**
 * Preview a invoice.
 * # Preview a invoice.
 */
export const apiInvoicespreviewFormatPost = <ThrowOnError extends boolean = false>(options: Options<ApiInvoicespreviewFormatPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApiInvoicespreviewFormatPostResponses, ApiInvoicespreviewFormatPostErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/invoices/preview',
        ...options,
        headers: {
            'Content-Type': 'application/ld+json',
            ...options.headers
        }
    });
};

/**
 * Get invoice by ID for customer
 * Retrieves a Invoice resource.
 */
export const apiInvoicespublicIdFormatGet = <ThrowOnError extends boolean = false>(options: Options<ApiInvoicespublicIdFormatGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiInvoicespublicIdFormatGetResponses, ApiInvoicespublicIdFormatGetErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/invoices/public/{id}',
        ...options
    });
};

/**
 * Resend an invoice.
 * Creates a ResendInvoiceResource resource.
 */
export const apiInvoicesresendIdFormatPost = <ThrowOnError extends boolean = false>(options: Options<ApiInvoicesresendIdFormatPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApiInvoicesresendIdFormatPostResponses, ApiInvoicesresendIdFormatPostErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/invoices/resend/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/ld+json',
            ...options.headers
        }
    });
};

/**
 * Get invoice by ID
 * Retrieves a Invoice resource.
 */
export const apiInvoicesIdFormatGet = <ThrowOnError extends boolean = false>(options: Options<ApiInvoicesIdFormatGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiInvoicesIdFormatGetResponses, ApiInvoicesIdFormatGetErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/invoices/{id}',
        ...options
    });
};

/**
 * Update an invoice.
 * # Update an invoice.
 */
export const apiInvoicesIdFormatPatch = <ThrowOnError extends boolean = false>(options: Options<ApiInvoicesIdFormatPatchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<ApiInvoicesIdFormatPatchResponses, ApiInvoicesIdFormatPatchErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/invoices/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/merge-patch+json',
            ...options.headers
        }
    });
};

/**
 * Get merchant defined fields
 * Retrieves the collection of MerchantDefinedField resources.
 */
export const apiMerchantDefinedFieldsFormatGetCollection = <ThrowOnError extends boolean = false>(options: Options<ApiMerchantDefinedFieldsFormatGetCollectionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiMerchantDefinedFieldsFormatGetCollectionResponses, unknown, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/merchant_defined_fields',
        ...options
    });
};

/**
 * Create a merchant defined field.
 * # Create a merchant defined field.
 */
export const apiMerchantDefinedFieldsFormatPost = <ThrowOnError extends boolean = false>(options: Options<ApiMerchantDefinedFieldsFormatPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApiMerchantDefinedFieldsFormatPostResponses, ApiMerchantDefinedFieldsFormatPostErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/merchant_defined_fields',
        ...options,
        headers: {
            'Content-Type': 'application/ld+json',
            ...options.headers
        }
    });
};

/**
 * Delete a merchant defined fields
 * Removes the MerchantDefinedField resource.
 */
export const apiMerchantDefinedFieldsIdFormatDelete = <ThrowOnError extends boolean = false>(options: Options<ApiMerchantDefinedFieldsIdFormatDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<ApiMerchantDefinedFieldsIdFormatDeleteResponses, ApiMerchantDefinedFieldsIdFormatDeleteErrors, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/merchant_defined_fields/{id}',
        ...options
    });
};

/**
 * Get merchant defined field by ID
 * Retrieves a MerchantDefinedField resource.
 */
export const apiMerchantDefinedFieldsIdFormatGet = <ThrowOnError extends boolean = false>(options: Options<ApiMerchantDefinedFieldsIdFormatGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiMerchantDefinedFieldsIdFormatGetResponses, ApiMerchantDefinedFieldsIdFormatGetErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/merchant_defined_fields/{id}',
        ...options
    });
};

/**
 * Update a merchant defined field.
 * # Update a merchant defined field.
 */
export const apiMerchantDefinedFieldsIdFormatPatch = <ThrowOnError extends boolean = false>(options: Options<ApiMerchantDefinedFieldsIdFormatPatchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<ApiMerchantDefinedFieldsIdFormatPatchResponses, ApiMerchantDefinedFieldsIdFormatPatchErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/merchant_defined_fields/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/merge-patch+json',
            ...options.headers
        }
    });
};

/**
 * Retrieves the collection of MerchantSettings resources.
 * Retrieves the collection of MerchantSettings resources.
 */
export const apiMerchantsFormatGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiMerchantsFormatGetCollectionData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ApiMerchantsFormatGetCollectionResponses, unknown, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/merchants',
        ...options
    });
};

/**
 * Creates a PostMerchantSettingResource resource.
 * Creates a PostMerchantSettingResource resource.
 */
export const apiMerchantsFormatPost = <ThrowOnError extends boolean = false>(options: Options<ApiMerchantsFormatPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApiMerchantsFormatPostResponses, ApiMerchantsFormatPostErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/merchants',
        ...options,
        headers: {
            'Content-Type': 'application/ld+json',
            ...options.headers
        }
    });
};

/**
 * Removes the DeleteMerchantSettingResource resource.
 * Removes the DeleteMerchantSettingResource resource.
 */
export const apiMerchantsMerchAccountIdFormatDelete = <ThrowOnError extends boolean = false>(options: Options<ApiMerchantsMerchAccountIdFormatDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<ApiMerchantsMerchAccountIdFormatDeleteResponses, ApiMerchantsMerchAccountIdFormatDeleteErrors, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/merchants/{merch_account_id}',
        ...options
    });
};

/**
 * Retrieves a MerchantSettings resource.
 * Retrieves a MerchantSettings resource.
 */
export const apiMerchantsMerchAccountIdFormatGet = <ThrowOnError extends boolean = false>(options: Options<ApiMerchantsMerchAccountIdFormatGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiMerchantsMerchAccountIdFormatGetResponses, ApiMerchantsMerchAccountIdFormatGetErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/merchants/{merch_account_id}',
        ...options
    });
};

/**
 * Updates the PatchMerchantSettingResource resource.
 * Updates the PatchMerchantSettingResource resource.
 */
export const apiMerchantsMerchAccountIdFormatPatch = <ThrowOnError extends boolean = false>(options: Options<ApiMerchantsMerchAccountIdFormatPatchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<ApiMerchantsMerchAccountIdFormatPatchResponses, ApiMerchantsMerchAccountIdFormatPatchErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/merchants/{merch_account_id}',
        ...options,
        headers: {
            'Content-Type': 'application/merge-patch+json',
            ...options.headers
        }
    });
};

/**
 * A collection of object files
 * Retrieves the collection of ObjectFile resources.
 */
export const apiObjectFilesFormatGetCollection = <ThrowOnError extends boolean = false>(options: Options<ApiObjectFilesFormatGetCollectionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiObjectFilesFormatGetCollectionResponses, unknown, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/object_files',
        ...options
    });
};

/**
 * Upload new object file.
 * # Upload new object file.
 */
export const apiObjectFilesFormatPost = <ThrowOnError extends boolean = false>(options: Options<ApiObjectFilesFormatPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApiObjectFilesFormatPostResponses, ApiObjectFilesFormatPostErrors, ThrowOnError>({
        ...formDataBodySerializer,
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/object_files',
        ...options,
        headers: {
            'Content-Type': null,
            ...options.headers
        }
    });
};

/**
 * Get a single payment by ID.
 * Retrieves a Payment resource.
 */
export const apiPaymentsIdFormatGet = <ThrowOnError extends boolean = false>(options: Options<ApiPaymentsIdFormatGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiPaymentsIdFormatGetResponses, ApiPaymentsIdFormatGetErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/payments/{id}',
        ...options
    });
};

/**
 * A collection of product categories
 * Retrieves the collection of Category resources.
 */
export const apiProductCategoriesFormatGetCollection = <ThrowOnError extends boolean = false>(options: Options<ApiProductCategoriesFormatGetCollectionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiProductCategoriesFormatGetCollectionResponses, unknown, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/product_categories',
        ...options
    });
};

/**
 * Create new category.
 * # Create new category.
 */
export const apiProductCategoriesFormatPost = <ThrowOnError extends boolean = false>(options: Options<ApiProductCategoriesFormatPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApiProductCategoriesFormatPostResponses, ApiProductCategoriesFormatPostErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/product_categories',
        ...options,
        headers: {
            'Content-Type': 'application/ld+json',
            ...options.headers
        }
    });
};

/**
 * Delete a category.
 * # Delete a category.
 */
export const apiProductCategoriesIdFormatDelete = <ThrowOnError extends boolean = false>(options: Options<ApiProductCategoriesIdFormatDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<ApiProductCategoriesIdFormatDeleteResponses, ApiProductCategoriesIdFormatDeleteErrors, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/product_categories/{id}',
        ...options
    });
};

/**
 * Get a single category.
 * Retrieves a Category resource.
 */
export const apiProductCategoriesIdFormatGet = <ThrowOnError extends boolean = false>(options: Options<ApiProductCategoriesIdFormatGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiProductCategoriesIdFormatGetResponses, ApiProductCategoriesIdFormatGetErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/product_categories/{id}',
        ...options
    });
};

/**
 * Update a category.
 * # Update a category.
 */
export const apiProductCategoriesIdFormatPatch = <ThrowOnError extends boolean = false>(options: Options<ApiProductCategoriesIdFormatPatchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<ApiProductCategoriesIdFormatPatchResponses, ApiProductCategoriesIdFormatPatchErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/product_categories/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/merge-patch+json',
            ...options.headers
        }
    });
};

/**
 * A collection of product details by location
 * Retrieves the collection of ProductDetailByLocation resources.
 */
export const apiProductDetailByLocationFormatGetCollection = <ThrowOnError extends boolean = false>(options: Options<ApiProductDetailByLocationFormatGetCollectionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiProductDetailByLocationFormatGetCollectionResponses, unknown, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/product_detail_by_location',
        ...options
    });
};

/**
 * Create new product detail by location.
 * # Create new product detail by location.
 */
export const apiProductDetailByLocationFormatPost = <ThrowOnError extends boolean = false>(options: Options<ApiProductDetailByLocationFormatPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApiProductDetailByLocationFormatPostResponses, ApiProductDetailByLocationFormatPostErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/product_detail_by_location',
        ...options,
        headers: {
            'Content-Type': 'application/ld+json',
            ...options.headers
        }
    });
};

/**
 * Delete a product detail by location.
 * # Delete a product detail by location.
 */
export const apiProductDetailByLocationIdFormatDelete = <ThrowOnError extends boolean = false>(options: Options<ApiProductDetailByLocationIdFormatDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<ApiProductDetailByLocationIdFormatDeleteResponses, ApiProductDetailByLocationIdFormatDeleteErrors, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/product_detail_by_location/{id}',
        ...options
    });
};

/**
 * Get a single product detail by location.
 * Retrieves a ProductDetailByLocation resource.
 */
export const apiProductDetailByLocationIdFormatGet = <ThrowOnError extends boolean = false>(options: Options<ApiProductDetailByLocationIdFormatGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiProductDetailByLocationIdFormatGetResponses, ApiProductDetailByLocationIdFormatGetErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/product_detail_by_location/{id}',
        ...options
    });
};

/**
 * Update a product detail by location.
 * # Update a product detail by location.
 */
export const apiProductDetailByLocationIdFormatPatch = <ThrowOnError extends boolean = false>(options: Options<ApiProductDetailByLocationIdFormatPatchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<ApiProductDetailByLocationIdFormatPatchResponses, ApiProductDetailByLocationIdFormatPatchErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/product_detail_by_location/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/merge-patch+json',
            ...options.headers
        }
    });
};

/**
 * A collection of product locations
 * Retrieves the collection of Location resources.
 */
export const apiProductLocationsFormatGetCollection = <ThrowOnError extends boolean = false>(options: Options<ApiProductLocationsFormatGetCollectionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiProductLocationsFormatGetCollectionResponses, unknown, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/product_locations',
        ...options
    });
};

/**
 * Create new location.
 * # Create new location.
 */
export const apiProductLocationsFormatPost = <ThrowOnError extends boolean = false>(options: Options<ApiProductLocationsFormatPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApiProductLocationsFormatPostResponses, ApiProductLocationsFormatPostErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/product_locations',
        ...options,
        headers: {
            'Content-Type': 'application/ld+json',
            ...options.headers
        }
    });
};

/**
 * Delete a location.
 * # Delete a location.
 */
export const apiProductLocationsIdFormatDelete = <ThrowOnError extends boolean = false>(options: Options<ApiProductLocationsIdFormatDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<ApiProductLocationsIdFormatDeleteResponses, ApiProductLocationsIdFormatDeleteErrors, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/product_locations/{id}',
        ...options
    });
};

/**
 * Get a single location.
 * Retrieves a Location resource.
 */
export const apiProductLocationsIdFormatGet = <ThrowOnError extends boolean = false>(options: Options<ApiProductLocationsIdFormatGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiProductLocationsIdFormatGetResponses, ApiProductLocationsIdFormatGetErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/product_locations/{id}',
        ...options
    });
};

/**
 * Update a location.
 * # Update a location.
 */
export const apiProductLocationsIdFormatPatch = <ThrowOnError extends boolean = false>(options: Options<ApiProductLocationsIdFormatPatchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<ApiProductLocationsIdFormatPatchResponses, ApiProductLocationsIdFormatPatchErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/product_locations/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/merge-patch+json',
            ...options.headers
        }
    });
};

/**
 * Get list product detail by location by package.
 * Retrieves the collection of PackageProductDetailByLocation resources.
 */
export const apiProductPackageProductDetailByLocationPackageIdFormatGetCollection = <ThrowOnError extends boolean = false>(options: Options<ApiProductPackageProductDetailByLocationPackageIdFormatGetCollectionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiProductPackageProductDetailByLocationPackageIdFormatGetCollectionResponses, unknown, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/product_package_product_detail_by_location/{package_id}',
        ...options
    });
};

/**
 * A collection of product packages
 * Retrieves the collection of Package resources.
 */
export const apiProductPackagesFormatGetCollection = <ThrowOnError extends boolean = false>(options: Options<ApiProductPackagesFormatGetCollectionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiProductPackagesFormatGetCollectionResponses, unknown, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/product_packages',
        ...options
    });
};

/**
 * Create new package.
 * # Create new package.
 */
export const apiProductPackagesFormatPost = <ThrowOnError extends boolean = false>(options: Options<ApiProductPackagesFormatPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApiProductPackagesFormatPostResponses, ApiProductPackagesFormatPostErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/product_packages',
        ...options,
        headers: {
            'Content-Type': 'application/ld+json',
            ...options.headers
        }
    });
};

/**
 * Delete a package.
 * # Delete a package.
 */
export const apiProductPackagesIdFormatDelete = <ThrowOnError extends boolean = false>(options: Options<ApiProductPackagesIdFormatDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<ApiProductPackagesIdFormatDeleteResponses, ApiProductPackagesIdFormatDeleteErrors, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/product_packages/{id}',
        ...options
    });
};

/**
 * Get a single package.
 * Retrieves a Package resource.
 */
export const apiProductPackagesIdFormatGet = <ThrowOnError extends boolean = false>(options: Options<ApiProductPackagesIdFormatGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiProductPackagesIdFormatGetResponses, ApiProductPackagesIdFormatGetErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/product_packages/{id}',
        ...options
    });
};

/**
 * Update a package.
 * # Update a package.
 */
export const apiProductPackagesIdFormatPatch = <ThrowOnError extends boolean = false>(options: Options<ApiProductPackagesIdFormatPatchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<ApiProductPackagesIdFormatPatchResponses, ApiProductPackagesIdFormatPatchErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/product_packages/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/merge-patch+json',
            ...options.headers
        }
    });
};

/**
 * Get list stock order item of stock order.
 * Retrieves the collection of StockOrderItem resources.
 */
export const apiProductStockOrderItemsStockOrderIdFormatGetCollection = <ThrowOnError extends boolean = false>(options: Options<ApiProductStockOrderItemsStockOrderIdFormatGetCollectionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiProductStockOrderItemsStockOrderIdFormatGetCollectionResponses, unknown, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/product_stock_order_items/{stock_order_id}',
        ...options
    });
};

/**
 * Update a stock order status.
 * # Update a stock order status.
 */
export const apiProductStockOrderStatusIdFormatPatch = <ThrowOnError extends boolean = false>(options: Options<ApiProductStockOrderStatusIdFormatPatchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<ApiProductStockOrderStatusIdFormatPatchResponses, ApiProductStockOrderStatusIdFormatPatchErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/product_stock_order_status/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/merge-patch+json',
            ...options.headers
        }
    });
};

/**
 * A collection of stock orders
 * Retrieves the collection of StockOrder resources.
 */
export const apiProductStockOrdersFormatGetCollection = <ThrowOnError extends boolean = false>(options: Options<ApiProductStockOrdersFormatGetCollectionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiProductStockOrdersFormatGetCollectionResponses, unknown, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/product_stock_orders',
        ...options
    });
};

/**
 * Create new stock order.
 * # Create new stock order.
 */
export const apiProductStockOrdersFormatPost = <ThrowOnError extends boolean = false>(options: Options<ApiProductStockOrdersFormatPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApiProductStockOrdersFormatPostResponses, ApiProductStockOrdersFormatPostErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/product_stock_orders',
        ...options,
        headers: {
            'Content-Type': 'application/ld+json',
            ...options.headers
        }
    });
};

/**
 * Delete a stock order.
 * # Delete a stock order.
 */
export const apiProductStockOrdersIdFormatDelete = <ThrowOnError extends boolean = false>(options: Options<ApiProductStockOrdersIdFormatDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<ApiProductStockOrdersIdFormatDeleteResponses, ApiProductStockOrdersIdFormatDeleteErrors, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/product_stock_orders/{id}',
        ...options
    });
};

/**
 * Get a single stock order.
 * Retrieves a StockOrder resource.
 */
export const apiProductStockOrdersIdFormatGet = <ThrowOnError extends boolean = false>(options: Options<ApiProductStockOrdersIdFormatGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiProductStockOrdersIdFormatGetResponses, ApiProductStockOrdersIdFormatGetErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/product_stock_orders/{id}',
        ...options
    });
};

/**
 * Update a stock order.
 * # Update a stock order.
 */
export const apiProductStockOrdersIdFormatPatch = <ThrowOnError extends boolean = false>(options: Options<ApiProductStockOrdersIdFormatPatchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<ApiProductStockOrdersIdFormatPatchResponses, ApiProductStockOrdersIdFormatPatchErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/product_stock_orders/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/merge-patch+json',
            ...options.headers
        }
    });
};

/**
 * A collection of products
 * Retrieves the collection of Product resources.
 */
export const apiProductsFormatGetCollection = <ThrowOnError extends boolean = false>(options: Options<ApiProductsFormatGetCollectionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiProductsFormatGetCollectionResponses, unknown, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/products',
        ...options
    });
};

/**
 * Create new product.
 * # Create new product.
 */
export const apiProductsFormatPost = <ThrowOnError extends boolean = false>(options: Options<ApiProductsFormatPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApiProductsFormatPostResponses, ApiProductsFormatPostErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/products',
        ...options,
        headers: {
            'Content-Type': 'application/ld+json',
            ...options.headers
        }
    });
};

/**
 * Delete a product.
 * # Delete a product.
 */
export const apiProductsIdFormatDelete = <ThrowOnError extends boolean = false>(options: Options<ApiProductsIdFormatDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<ApiProductsIdFormatDeleteResponses, ApiProductsIdFormatDeleteErrors, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/products/{id}',
        ...options
    });
};

/**
 * Get a single product.
 * Retrieves a Product resource.
 */
export const apiProductsIdFormatGet = <ThrowOnError extends boolean = false>(options: Options<ApiProductsIdFormatGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiProductsIdFormatGetResponses, ApiProductsIdFormatGetErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/products/{id}',
        ...options
    });
};

/**
 * Update a product.
 * # Update a product.
 */
export const apiProductsIdFormatPatch = <ThrowOnError extends boolean = false>(options: Options<ApiProductsIdFormatPatchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<ApiProductsIdFormatPatchResponses, ApiProductsIdFormatPatchErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/products/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/merge-patch+json',
            ...options.headers
        }
    });
};

/**
 * A collection of plans
 * Retrieves the collection of Plan resources.
 */
export const apiPlansFormatGetCollection = <ThrowOnError extends boolean = false>(options: Options<ApiPlansFormatGetCollectionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiPlansFormatGetCollectionResponses, unknown, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/plans',
        ...options
    });
};

/**
 * Create new plan
 * # Create new plan
 */
export const apiPlansFormatPost = <ThrowOnError extends boolean = false>(options: Options<ApiPlansFormatPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApiPlansFormatPostResponses, ApiPlansFormatPostErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/plans',
        ...options,
        headers: {
            'Content-Type': 'application/ld+json',
            ...options.headers
        }
    });
};

/**
 * Delete a plan
 * Removes the Plan resource.
 */
export const apiPlansIdFormatDelete = <ThrowOnError extends boolean = false>(options: Options<ApiPlansIdFormatDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<ApiPlansIdFormatDeleteResponses, ApiPlansIdFormatDeleteErrors, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/plans/{id}',
        ...options
    });
};

/**
 * Get a single plan
 * Retrieves a Plan resource.
 */
export const apiPlansIdFormatGet = <ThrowOnError extends boolean = false>(options: Options<ApiPlansIdFormatGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiPlansIdFormatGetResponses, ApiPlansIdFormatGetErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/plans/{id}',
        ...options
    });
};

/**
 * Update a plan
 * Updates the PatchPlanResource resource.
 */
export const apiPlansIdFormatPatch = <ThrowOnError extends boolean = false>(options: Options<ApiPlansIdFormatPatchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<ApiPlansIdFormatPatchResponses, ApiPlansIdFormatPatchErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/plans/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/merge-patch+json',
            ...options.headers
        }
    });
};

/**
 * Update status a recur
 * Updates the PatchRecurStatusResource resource.
 */
export const apiRecurStatusRecurIdFormatPatch = <ThrowOnError extends boolean = false>(options: Options<ApiRecurStatusRecurIdFormatPatchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<ApiRecurStatusRecurIdFormatPatchResponses, ApiRecurStatusRecurIdFormatPatchErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/recur_status/{recur_id}',
        ...options,
        headers: {
            'Content-Type': 'application/merge-patch+json',
            ...options.headers
        }
    });
};

/**
 * A collection of recurs
 * Retrieves the collection of Recur resources.
 */
export const apiRecursFormatGetCollection = <ThrowOnError extends boolean = false>(options: Options<ApiRecursFormatGetCollectionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiRecursFormatGetCollectionResponses, unknown, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/recurs',
        ...options
    });
};

/**
 * Create new recur
 * # Create new recur
 */
export const apiRecursFormatPost = <ThrowOnError extends boolean = false>(options: Options<ApiRecursFormatPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApiRecursFormatPostResponses, ApiRecursFormatPostErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/recurs',
        ...options,
        headers: {
            'Content-Type': 'application/ld+json',
            ...options.headers
        }
    });
};

/**
 * Delete a recur
 * Removes the Recur resource.
 */
export const apiRecursIdFormatDelete = <ThrowOnError extends boolean = false>(options: Options<ApiRecursIdFormatDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<ApiRecursIdFormatDeleteResponses, ApiRecursIdFormatDeleteErrors, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/recurs/{id}',
        ...options
    });
};

/**
 * Get a single recur.
 * Retrieves a Recur resource.
 */
export const apiRecursIdFormatGet = <ThrowOnError extends boolean = false>(options: Options<ApiRecursIdFormatGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiRecursIdFormatGetResponses, ApiRecursIdFormatGetErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/recurs/{id}',
        ...options
    });
};

/**
 * Update a recur
 * Updates the PatchRecurResource resource.
 */
export const apiRecursIdFormatPatch = <ThrowOnError extends boolean = false>(options: Options<ApiRecursIdFormatPatchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<ApiRecursIdFormatPatchResponses, ApiRecursIdFormatPatchErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/recurs/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/merge-patch+json',
            ...options.headers
        }
    });
};

/**
 * Retrieves a Signature resource.
 * Retrieves a Signature resource.
 */
export const apiTransactionSignatureIdFormatGet = <ThrowOnError extends boolean = false>(options: Options<ApiTransactionSignatureIdFormatGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiTransactionSignatureIdFormatGetResponses, ApiTransactionSignatureIdFormatGetErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/transaction_signature/{id}',
        ...options
    });
};

/**
 * Manage batch request by batch id.
 * Creates a PostReopenBatchResource resource.
 */
export const apiBatchesreopenBatchIdFormatPost = <ThrowOnError extends boolean = false>(options: Options<ApiBatchesreopenBatchIdFormatPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApiBatchesreopenBatchIdFormatPostResponses, ApiBatchesreopenBatchIdFormatPostErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/batches/reopen/{batch_id}',
        ...options
    });
};

/**
 * Retrieves the collection of BDK resources.
 * Retrieves the collection of BDK resources.
 */
export const apiManagebdkFormatGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiManagebdkFormatGetCollectionData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ApiManagebdkFormatGetCollectionResponses, ApiManagebdkFormatGetCollectionErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/manage/bdk',
        ...options
    });
};

/**
 * Creates a PostBDKResource resource.
 * Creates a PostBDKResource resource.
 */
export const apiManagebdkFormatPost = <ThrowOnError extends boolean = false>(options: Options<ApiManagebdkFormatPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApiManagebdkFormatPostResponses, ApiManagebdkFormatPostErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/manage/bdk',
        ...options,
        headers: {
            'Content-Type': 'application/ld+json',
            ...options.headers
        }
    });
};

/**
 * Removes the BDK resource.
 * Removes the BDK resource.
 */
export const apiManagebdkIdFormatDelete = <ThrowOnError extends boolean = false>(options: Options<ApiManagebdkIdFormatDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<ApiManagebdkIdFormatDeleteResponses, ApiManagebdkIdFormatDeleteErrors, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/manage/bdk/{id}',
        ...options
    });
};

/**
 * Retrieves a BDK resource.
 * Retrieves a BDK resource.
 */
export const apiManagebdkIdFormatGet = <ThrowOnError extends boolean = false>(options: Options<ApiManagebdkIdFormatGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiManagebdkIdFormatGetResponses, ApiManagebdkIdFormatGetErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/manage/bdk/{id}',
        ...options
    });
};

/**
 * Updates the PatchBDKResource resource.
 * Updates the PatchBDKResource resource.
 */
export const apiManagebdkIdFormatPatch = <ThrowOnError extends boolean = false>(options: Options<ApiManagebdkIdFormatPatchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<ApiManagebdkIdFormatPatchResponses, ApiManagebdkIdFormatPatchErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/manage/bdk/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/merge-patch+json',
            ...options.headers
        }
    });
};

/**
 * Retrieves the collection of AllTransaction resources.
 * Retrieves the collection of AllTransaction resources.
 */
export const apiTransactionsallFormatGetCollection = <ThrowOnError extends boolean = false>(options: Options<ApiTransactionsallFormatGetCollectionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiTransactionsallFormatGetCollectionResponses, unknown, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/transactions/all',
        ...options
    });
};

/**
 * Creates a AuthToSaleResource resource.
 * Creates a AuthToSaleResource resource.
 */
export const apiTransactionsauthToSaleFormatPost = <ThrowOnError extends boolean = false>(options: Options<ApiTransactionsauthToSaleFormatPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApiTransactionsauthToSaleFormatPostResponses, ApiTransactionsauthToSaleFormatPostErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/transactions/auth_to_sale',
        ...options,
        headers: {
            'Content-Type': 'application/ld+json',
            ...options.headers
        }
    });
};

/**
 * Creates a BatchCloseResource resource.
 * Creates a BatchCloseResource resource.
 */
export const apiTransactionsbatchCloseFormatPost = <ThrowOnError extends boolean = false>(options: Options<ApiTransactionsbatchCloseFormatPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApiTransactionsbatchCloseFormatPostResponses, ApiTransactionsbatchCloseFormatPostErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/transactions/batch_close',
        ...options,
        headers: {
            'Content-Type': 'application/ld+json',
            ...options.headers
        }
    });
};

/**
 * Retrieves the collection of BatchedTransaction resources.
 * Retrieves the collection of BatchedTransaction resources.
 */
export const apiTransactionsbatchedFormatGetCollection = <ThrowOnError extends boolean = false>(options: Options<ApiTransactionsbatchedFormatGetCollectionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiTransactionsbatchedFormatGetCollectionResponses, unknown, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/transactions/batched',
        ...options
    });
};

/**
 * Retrieves a BatchedTransaction resource.
 * Retrieves a BatchedTransaction resource.
 */
export const apiTransactionsbatchedTransactionIdFormatGet = <ThrowOnError extends boolean = false>(options: Options<ApiTransactionsbatchedTransactionIdFormatGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiTransactionsbatchedTransactionIdFormatGetResponses, ApiTransactionsbatchedTransactionIdFormatGetErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/transactions/batched/{transaction_id}',
        ...options
    });
};

/**
 * Creates a BlindReturnResource resource.
 * Creates a BlindReturnResource resource.
 */
export const apiTransactionsblindReturnFormatPost = <ThrowOnError extends boolean = false>(options: Options<ApiTransactionsblindReturnFormatPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApiTransactionsblindReturnFormatPostResponses, ApiTransactionsblindReturnFormatPostErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/transactions/blind_return',
        ...options,
        headers: {
            'Content-Type': 'application/ld+json',
            ...options.headers
        }
    });
};

/**
 * Creates a CheckStoreResource resource.
 * Creates a CheckStoreResource resource.
 */
export const apiTransactionscheckStoreFormatPost = <ThrowOnError extends boolean = false>(options: Options<ApiTransactionscheckStoreFormatPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApiTransactionscheckStoreFormatPostResponses, ApiTransactionscheckStoreFormatPostErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/transactions/check_store',
        ...options,
        headers: {
            'Content-Type': 'application/ld+json',
            ...options.headers
        }
    });
};

/**
 * Retrieves the collection of DeclinedTransaction resources.
 * Retrieves the collection of DeclinedTransaction resources.
 */
export const apiTransactionsdeclinedFormatGetCollection = <ThrowOnError extends boolean = false>(options: Options<ApiTransactionsdeclinedFormatGetCollectionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiTransactionsdeclinedFormatGetCollectionResponses, unknown, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/transactions/declined',
        ...options
    });
};

/**
 * Retrieves a DeclinedTransaction resource.
 * Retrieves a DeclinedTransaction resource.
 */
export const apiTransactionsdeclinedTransactionIdFormatGet = <ThrowOnError extends boolean = false>(options: Options<ApiTransactionsdeclinedTransactionIdFormatGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiTransactionsdeclinedTransactionIdFormatGetResponses, ApiTransactionsdeclinedTransactionIdFormatGetErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/transactions/declined/{transaction_id}',
        ...options
    });
};

/**
 * Retrieves the collection of ErrorTransaction resources.
 * Retrieves the collection of ErrorTransaction resources.
 */
export const apiTransactionserrorFormatGetCollection = <ThrowOnError extends boolean = false>(options: Options<ApiTransactionserrorFormatGetCollectionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiTransactionserrorFormatGetCollectionResponses, unknown, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/transactions/error',
        ...options
    });
};

/**
 * Retrieves a ErrorTransaction resource.
 * Retrieves a ErrorTransaction resource.
 */
export const apiTransactionserrorTransactionIdFormatGet = <ThrowOnError extends boolean = false>(options: Options<ApiTransactionserrorTransactionIdFormatGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiTransactionserrorTransactionIdFormatGetResponses, ApiTransactionserrorTransactionIdFormatGetErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/transactions/error/{transaction_id}',
        ...options
    });
};

/**
 * Creates a IncrementalResource resource.
 * Creates a IncrementalResource resource.
 */
export const apiTransactionsincrementalFormatPost = <ThrowOnError extends boolean = false>(options: Options<ApiTransactionsincrementalFormatPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApiTransactionsincrementalFormatPostResponses, ApiTransactionsincrementalFormatPostErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/transactions/incremental',
        ...options,
        headers: {
            'Content-Type': 'application/ld+json',
            ...options.headers
        }
    });
};

/**
 * Creates a ReEnterResource resource.
 * Creates a ReEnterResource resource.
 */
export const apiTransactionsreEnterFormatPost = <ThrowOnError extends boolean = false>(options: Options<ApiTransactionsreEnterFormatPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApiTransactionsreEnterFormatPostResponses, ApiTransactionsreEnterFormatPostErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/transactions/re_enter',
        ...options,
        headers: {
            'Content-Type': 'application/ld+json',
            ...options.headers
        }
    });
};

/**
 * Creates a ReturnResource resource.
 * Creates a ReturnResource resource.
 */
export const apiTransactionsreturnFormatPost = <ThrowOnError extends boolean = false>(options: Options<ApiTransactionsreturnFormatPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApiTransactionsreturnFormatPostResponses, ApiTransactionsreturnFormatPostErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/transactions/return',
        ...options,
        headers: {
            'Content-Type': 'application/ld+json',
            ...options.headers
        }
    });
};

/**
 * Creates a ReversalResource resource.
 * Creates a ReversalResource resource.
 */
export const apiTransactionsreversalFormatPost = <ThrowOnError extends boolean = false>(options: Options<ApiTransactionsreversalFormatPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApiTransactionsreversalFormatPostResponses, ApiTransactionsreversalFormatPostErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/transactions/reversal',
        ...options,
        headers: {
            'Content-Type': 'application/ld+json',
            ...options.headers
        }
    });
};

/**
 * Creates a SaleResource resource.
 * Creates a SaleResource resource.
 */
export const apiTransactionssaleFormatPost = <ThrowOnError extends boolean = false>(options: Options<ApiTransactionssaleFormatPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApiTransactionssaleFormatPostResponses, ApiTransactionssaleFormatPostErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/transactions/sale',
        ...options,
        headers: {
            'Content-Type': 'application/ld+json',
            ...options.headers
        }
    });
};

/**
 * Retrieves the collection of SettledTransaction resources.
 * Retrieves the collection of SettledTransaction resources.
 */
export const apiTransactionssettledFormatGetCollection = <ThrowOnError extends boolean = false>(options: Options<ApiTransactionssettledFormatGetCollectionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiTransactionssettledFormatGetCollectionResponses, unknown, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/transactions/settled',
        ...options
    });
};

/**
 * Retrieves a SettledTransaction resource.
 * Retrieves a SettledTransaction resource.
 */
export const apiTransactionssettledTransactionIdFormatGet = <ThrowOnError extends boolean = false>(options: Options<ApiTransactionssettledTransactionIdFormatGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiTransactionssettledTransactionIdFormatGetResponses, ApiTransactionssettledTransactionIdFormatGetErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/transactions/settled/{transaction_id}',
        ...options
    });
};

/**
 * Creates a StoreResource resource.
 * Creates a StoreResource resource.
 */
export const apiTransactionsstoreFormatPost = <ThrowOnError extends boolean = false>(options: Options<ApiTransactionsstoreFormatPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApiTransactionsstoreFormatPostResponses, ApiTransactionsstoreFormatPostErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/transactions/store',
        ...options,
        headers: {
            'Content-Type': 'application/ld+json',
            ...options.headers
        }
    });
};

/**
 * Creates a VoidResource resource.
 * Creates a VoidResource resource.
 */
export const apiTransactionsvoidFormatPost = <ThrowOnError extends boolean = false>(options: Options<ApiTransactionsvoidFormatPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApiTransactionsvoidFormatPostResponses, ApiTransactionsvoidFormatPostErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/transactions/void',
        ...options,
        headers: {
            'Content-Type': 'application/ld+json',
            ...options.headers
        }
    });
};

/**
 * Retrieves a GetTransactionReceiptResource resource.
 * Retrieves a GetTransactionReceiptResource resource.
 */
export const apiTransactionsTransactionIdreceiptFormatGet = <ThrowOnError extends boolean = false>(options: Options<ApiTransactionsTransactionIdreceiptFormatGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiTransactionsTransactionIdreceiptFormatGetResponses, ApiTransactionsTransactionIdreceiptFormatGetErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/transactions/{transaction_id}/receipt',
        ...options
    });
};

/**
 * A collection of users
 * Retrieves the collection of User resources.
 */
export const apiUsersFormatGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiUsersFormatGetCollectionData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ApiUsersFormatGetCollectionResponses, ApiUsersFormatGetCollectionErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/users',
        ...options
    });
};

/**
 * Register new user
 * # Register new user
 */
export const apiUsersPost = <ThrowOnError extends boolean = false>(options: Options<ApiUsersPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApiUsersPostResponses, ApiUsersPostErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/users',
        ...options,
        headers: {
            'Content-Type': 'application/ld+json',
            ...options.headers
        }
    });
};

/**
 * Get current user information
 * Retrieves a User resource.
 */
export const apiUsersmeFormatGet = <ThrowOnError extends boolean = false>(options?: Options<ApiUsersmeFormatGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ApiUsersmeFormatGetResponses, ApiUsersmeFormatGetErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/users/me',
        ...options
    });
};

/**
 * Updates the PatchChangePasswordResource resource.
 * Updates the PatchChangePasswordResource resource.
 */
export const apiUsersmechangePasswordFormatPatch = <ThrowOnError extends boolean = false>(options: Options<ApiUsersmechangePasswordFormatPatchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<ApiUsersmechangePasswordFormatPatchResponses, ApiUsersmechangePasswordFormatPatchErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/users/me/change_password',
        ...options,
        headers: {
            'Content-Type': 'application/merge-patch+json',
            ...options.headers
        }
    });
};

/**
 * Updates the PatchDisableMfaResource resource.
 * Updates the PatchDisableMfaResource resource.
 */
export const apiUsersmedisableMfaFormatPatch = <ThrowOnError extends boolean = false>(options: Options<ApiUsersmedisableMfaFormatPatchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<ApiUsersmedisableMfaFormatPatchResponses, ApiUsersmedisableMfaFormatPatchErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/users/me/disable_mfa',
        ...options,
        headers: {
            'Content-Type': 'application/merge-patch+json',
            ...options.headers
        }
    });
};

/**
 * Creates a PostGenerateBackupCodeResource resource.
 * Creates a PostGenerateBackupCodeResource resource.
 */
export const apiUsersmegenerateMfaBackupCodesFormatPost = <ThrowOnError extends boolean = false>(options: Options<ApiUsersmegenerateMfaBackupCodesFormatPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApiUsersmegenerateMfaBackupCodesFormatPostResponses, ApiUsersmegenerateMfaBackupCodesFormatPostErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/users/me/generate_mfa_backup_codes',
        ...options,
        headers: {
            'Content-Type': 'application/ld+json',
            ...options.headers
        }
    });
};

/**
 * Creates a PostGenerateEmailAuthCodeResource resource.
 * Creates a PostGenerateEmailAuthCodeResource resource.
 */
export const apiUsersmegenerateMfaEmailAuthCodeFormatPost = <ThrowOnError extends boolean = false>(options: Options<ApiUsersmegenerateMfaEmailAuthCodeFormatPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApiUsersmegenerateMfaEmailAuthCodeFormatPostResponses, ApiUsersmegenerateMfaEmailAuthCodeFormatPostErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/users/me/generate_mfa_email_auth_code',
        ...options,
        headers: {
            'Content-Type': 'application/ld+json',
            ...options.headers
        }
    });
};

/**
 * Creates a PostGenerateGoogleTotpResource resource.
 * Creates a PostGenerateGoogleTotpResource resource.
 */
export const apiUsersmegenerateMfaGoogleTotpFormatPost = <ThrowOnError extends boolean = false>(options: Options<ApiUsersmegenerateMfaGoogleTotpFormatPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApiUsersmegenerateMfaGoogleTotpFormatPostResponses, ApiUsersmegenerateMfaGoogleTotpFormatPostErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/users/me/generate_mfa_google_totp',
        ...options,
        headers: {
            'Content-Type': 'application/ld+json',
            ...options.headers
        }
    });
};

/**
 * Retrieves list MFA method enabled of current user
 * List MFA methods
 */
export const apiUsersmemfaProvidersFormatGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiUsersmemfaProvidersFormatGetCollectionData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ApiUsersmemfaProvidersFormatGetCollectionResponses, unknown, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/users/me/mfa_providers',
        ...options
    });
};

/**
 * Set MFA Provider using to authenticate request
 * Set MFA Provider
 */
export const apiUsersmemfaProvidersFormatPost = <ThrowOnError extends boolean = false>(options: Options<ApiUsersmemfaProvidersFormatPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApiUsersmemfaProvidersFormatPostResponses, ApiUsersmemfaProvidersFormatPostErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/users/me/mfa_providers',
        ...options,
        headers: {
            'Content-Type': 'application/ld+json',
            ...options.headers
        }
    });
};

/**
 * Updates the PatchPreferMfaProviderResource resource.
 * Updates the PatchPreferMfaProviderResource resource.
 */
export const apiUsersmepreferMfaFormatPatch = <ThrowOnError extends boolean = false>(options: Options<ApiUsersmepreferMfaFormatPatchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<ApiUsersmepreferMfaFormatPatchResponses, ApiUsersmepreferMfaFormatPatchErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/users/me/prefer_mfa',
        ...options,
        headers: {
            'Content-Type': 'application/merge-patch+json',
            ...options.headers
        }
    });
};

/**
 * Creates a PostSetupEmailAuthCodeResource resource.
 * Creates a PostSetupEmailAuthCodeResource resource.
 */
export const apiUsersmesetupMfaEmailAuthCodeFormatPost = <ThrowOnError extends boolean = false>(options: Options<ApiUsersmesetupMfaEmailAuthCodeFormatPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApiUsersmesetupMfaEmailAuthCodeFormatPostResponses, ApiUsersmesetupMfaEmailAuthCodeFormatPostErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/users/me/setup_mfa_email_auth_code',
        ...options,
        headers: {
            'Content-Type': 'application/ld+json',
            ...options.headers
        }
    });
};

/**
 * Creates a PostSetupGoogleTotpResource resource.
 * Creates a PostSetupGoogleTotpResource resource.
 */
export const apiUsersmesetupMfaGoogleTotpFormatPost = <ThrowOnError extends boolean = false>(options: Options<ApiUsersmesetupMfaGoogleTotpFormatPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApiUsersmesetupMfaGoogleTotpFormatPostResponses, ApiUsersmesetupMfaGoogleTotpFormatPostErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/users/me/setup_mfa_google_totp',
        ...options,
        headers: {
            'Content-Type': 'application/ld+json',
            ...options.headers
        }
    });
};

/**
 * Creates a ResetPasswordTokenResource resource.
 * Creates a ResetPasswordTokenResource resource.
 */
export const apiUsersrequestResetPasswordFormatPost = <ThrowOnError extends boolean = false>(options: Options<ApiUsersrequestResetPasswordFormatPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApiUsersrequestResetPasswordFormatPostResponses, ApiUsersrequestResetPasswordFormatPostErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/users/request_reset_password',
        ...options,
        headers: {
            'Content-Type': 'application/ld+json',
            ...options.headers
        }
    });
};

/**
 * MFA Reset
 * # Reset mfa and backup codes
 */
export const apiUsersresetMfaAccountIdFormatPatch = <ThrowOnError extends boolean = false>(options: Options<ApiUsersresetMfaAccountIdFormatPatchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<ApiUsersresetMfaAccountIdFormatPatchResponses, ApiUsersresetMfaAccountIdFormatPatchErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/users/reset_mfa/{account_id}',
        ...options,
        headers: {
            'Content-Type': 'application/merge-patch+json',
            ...options.headers
        }
    });
};

/**
 * Creates a ResetPasswordTokenResource resource.
 * Creates a ResetPasswordTokenResource resource.
 */
export const apiUsersresetPasswordFormatPost = <ThrowOnError extends boolean = false>(options: Options<ApiUsersresetPasswordFormatPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApiUsersresetPasswordFormatPostResponses, ApiUsersresetPasswordFormatPostErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/users/reset_password',
        ...options,
        headers: {
            'Content-Type': 'application/ld+json',
            ...options.headers
        }
    });
};

/**
 * Retrieves a ResetPasswordTokenResource resource.
 * Retrieves a ResetPasswordTokenResource resource.
 */
export const apiUsersresetPasswordIdFormatGet = <ThrowOnError extends boolean = false>(options: Options<ApiUsersresetPasswordIdFormatGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiUsersresetPasswordIdFormatGetResponses, ApiUsersresetPasswordIdFormatGetErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/users/reset_password/{id}',
        ...options
    });
};

/**
 * Delete a single user
 * Removes the User resource.
 */
export const apiUsersIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiUsersIdDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<ApiUsersIdDeleteResponses, ApiUsersIdDeleteErrors, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/users/{id}',
        ...options
    });
};

/**
 * A single user
 * Retrieves a User resource.
 */
export const apiUsersIdFormatGet = <ThrowOnError extends boolean = false>(options: Options<ApiUsersIdFormatGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiUsersIdFormatGetResponses, ApiUsersIdFormatGetErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/users/{id}',
        ...options
    });
};

/**
 * Update a single user
 * Updates the PatchUserResource resource.
 */
export const apiUsersIdFormatPatch = <ThrowOnError extends boolean = false>(options: Options<ApiUsersIdFormatPatchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<ApiUsersIdFormatPatchResponses, ApiUsersIdFormatPatchErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/users/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/merge-patch+json',
            ...options.headers
        }
    });
};